import { Button, Text } from "@ttc3k/trekker";
import { WidgetByIdQuery } from "gql/generated";
import { useTranslation } from "react-i18next";
import { getMultilingualString } from "shared/utils";
import { Flex } from "styled-system/jsx";

type SourceListProps = {
  widget: WidgetByIdQuery["widgetById"];
  onEditListItemsClick: () => void;
};

export const SourceList = ({
  widget,
  onEditListItemsClick,
}: SourceListProps) => {
  const { t } = useTranslation();

  return (
    <Flex flexDir="column" gap="150">
      <Text visual="smallLabel">
        {t("widgets:DETAILS.PAGE_ACTIONS.SOURCE_LIST")}
      </Text>
      <Button visual="unstyled" onClick={onEditListItemsClick}>
        <Text
          visual="bodyMedium"
          color="text.accent.blue.mid"
          style={{
            textDecoration: "underline",
          }}
          textAlign="left"
        >
          {getMultilingualString(widget.list.name)}
        </Text>
      </Button>
    </Flex>
  );
};
